// AuthCallback.jsx
import React, { useEffect, useContext, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useAPI } from "../context/ApiContext";
import { useTranslation } from "react-i18next";
import { SnackbarContext } from "../context/SnackbarContext";

const AuthCallback = () => {
  const history = useHistory();
  const { loginWithLineCode , loginWithGoogleCode } = useAPI();
  const { newSnack } = useContext(SnackbarContext);
  const didRun = useRef(false); // ★ 二重実行ガード
  const { t } = useTranslation();

  useEffect(() => {
    if (didRun.current) return; // ★ 2回目以降は無視
    didRun.current = true;

    (async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const state = params.get("state");
      const storedState = localStorage.getItem("oauth_state");
      const provider = localStorage.getItem("oauth_provider");
      const redirect_uri =
        process.env.REACT_APP_SOCIAL_REDIRECT_URI || `${window.location.origin}/auth/callback`;

      try {
        if (!code) throw new Error("code not found");
        if (provider === "line") {
            // LINE は自前で state/nonce を保存しているので厳格チェック
            if (!state || state !== storedState) throw new Error("invalid state");
            await loginWithLineCode({
              code,
              redirect_uri,
              nonce: localStorage.getItem("oauth_nonce"),
            });
          }
          else if (provider === "google") {
              if (!state || state !== storedState) throw new Error("invalid state");
              await loginWithGoogleCode({
                code,
                redirect_uri,
                nonce: localStorage.getItem("oauth_nonce"),
              });
            }

        // ★ クエリを消して再実行防止
        history.replace("/home");
        newSnack("success", t("AuthCallback1"));
      } catch (e) {
        history.replace("/login");
        newSnack("error", t("AuthCallback2"));
      } finally {
        localStorage.removeItem("oauth_state");
        localStorage.removeItem("oauth_nonce");
        localStorage.removeItem("oauth_provider");
      }
    })();
  }, [history, loginWithLineCode, newSnack]);

  return <div className="p-4 text-center">Authenticating…</div>;
};

export default AuthCallback;
